/* ==========================================================================
   DCA CLINICAL — quiz.js
   Drives the guided-quiz section. Content comes entirely from the theme
   editor; this file only counts votes and swaps panels.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  $$('[data-quiz]').forEach(function (root) {
    var payloadEl = $('[data-quiz-json]', root);
    if (!payloadEl) return;

    var data;
    try { data = JSON.parse(payloadEl.textContent); } catch (e) { return; }
    var questions = (data.questions || []).filter(function (q) {
      return q && q.title && q.answers && q.answers.length;
    });
    if (!questions.length) return;

    var gate = root.dataset.gate || 'none';
    var intro = $('[data-quiz-intro]', root);
    var panel = $('[data-quiz-questions]', root);
    var results = $('[data-quiz-results]', root);
    var titleEl = $('[data-quiz-title]', root);
    var stepEl = $('[data-quiz-step]', root);
    var answersEl = $('[data-quiz-answers]', root);
    var fillEl = $('[data-quiz-fill]', root);
    var backBtn = $('[data-quiz-back]', root);

    var index = 0;
    var picks = [];

    /* Scroll so the panel clears the sticky header rather than parking the
       content underneath it. */
    function scrollToPanel() {
      var header = document.querySelector('.header-wrap');
      var offset = (header ? header.offsetHeight : 0) + 20;
      var top = root.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }

    function renderQuestion() {
      var q = questions[index];
      if (!q) return;

      if (stepEl) {
        stepEl.textContent = (stepEl.dataset.template || 'Question [n] of [total]')
          .replace('[n]', index + 1)
          .replace('[total]', questions.length);
      }
      if (titleEl) titleEl.textContent = q.title;
      if (fillEl) fillEl.style.width = ((index) / questions.length * 100) + '%';
      if (backBtn) backBtn.hidden = index === 0;

      answersEl.innerHTML = '';
      q.answers.forEach(function (a) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'quiz__answer';
        btn.textContent = a.label;
        if (picks[index] === a.key) btn.classList.add('is-picked');
        btn.addEventListener('click', function () {
          picks[index] = a.key;
          if (index < questions.length - 1) {
            index++;
            renderQuestion();
          } else {
            showResult(score());
          }
        });
        answersEl.appendChild(btn);
      });
    }

    /* Highest vote count wins. Ties break toward the earliest question's pick,
       which keeps the outcome stable and explainable rather than arbitrary. */
    function score() {
      var tally = {};
      picks.forEach(function (k) {
        if (!k) return;
        tally[k] = (tally[k] || 0) + 1;
      });
      var best = null;
      var bestCount = -1;
      picks.forEach(function (k) {
        if (!k) return;
        if (tally[k] > bestCount) { best = k; bestCount = tally[k]; }
      });
      return best;
    }

    function showResult(key) {
      var blocks = $$('[data-quiz-result]', root);
      var match = null;
      blocks.forEach(function (b) {
        var isMatch = b.dataset.quizResult === key;
        b.hidden = !isMatch;
        if (isMatch) match = b;
      });
      /* No block matches the winning key — fall back to the first result
         rather than showing an empty page. */
      if (!match && blocks.length) {
        blocks[0].hidden = false;
      }
      if (fillEl) fillEl.style.width = '100%';
      if (intro) intro.hidden = true;
      if (panel) panel.hidden = true;
      if (results) results.hidden = false;
      scrollToPanel();
    }

    function start() {
      index = 0;
      picks = [];
      if (intro) intro.hidden = true;
      if (results) results.hidden = true;
      if (panel) panel.hidden = false;
      renderQuestion();
      scrollToPanel();
    }

    $$('[data-quiz-start]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        /* A "before" gate must actually collect something. Let the browser's
           own validation message do the work rather than inventing one. */
        if (gate === 'before' && btn.hasAttribute('data-requires-gate')) {
          var form = btn.closest('form');
          if (form && !form.reportValidity()) return;
        }
        start();
      });
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (index > 0) { index--; renderQuestion(); }
      });
    }

    $$('[data-quiz-restart]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (results) results.hidden = true;
        if (intro) intro.hidden = false;
        if (panel) panel.hidden = true;
        picks = [];
        index = 0;
        scrollToPanel();
      });
    });

    /* Deep link: ?goal=sleep jumps straight to that result, so an email or ad
       can land someone on their answer without re-taking the quiz. */
    var params = new URLSearchParams(window.location.search);
    var goal = params.get('goal');
    if (goal) {
      var target = $('[data-quiz-result="' + goal.replace(/"/g, '') + '"]', root);
      if (target) showResult(goal);
    }
  });
})();
